import { useOrgao } from "../contexts/orgao";

export function useCurrentOrgao(): number | undefined {
    const { currentOrgaoId } = useOrgao();
    return currentOrgaoId ?? undefined;
}

